import { useTranslation } from 'react-i18next';

import useStyles from './styles';

function Paragraphs({ id, n }: { id: string; n: number }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const nums = [...Array(n).keys()];

  return (
    <ul className={(classes.nameList, classes.noPadding)}>
      {nums.map((i) => {
        const text = t(`emojiPage.${id}.paragraphs.${i}`);

        return (
          <p key={text.slice(0, 8)} className={classes.paragraph}>
            {text}
          </p>
        );
      })}
    </ul>
  );
}

export default Paragraphs;
